/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

/**
 * This component changes the style of submit button
 */
var rootScope = require('../root-scope.service');

function enableSubmitButton() {
    var submitButton = rootScope.getSubmitButton();
    if (submitButton) {
        submitButton.removeAttr('disabled');
        submitButton.removeClass('disabled');
    }
}

function disableSubmitButton() {
    var submitButton = rootScope.getSubmitButton();
    if (submitButton) {
        submitButton.attr('disabled', 'disabled');
        submitButton.addClass('disabled');
    }
}

function disableButtonUneditable(formContainer, formId) {
    if (rootScope.isUpdate() && rootScope.isRegisteredAccount(formId) && formContainer.find('iframe,input,textarea,select').length === 0) {
        disableSubmitButton();
    } else {
        enableSubmitButton();
    }
}
module.exports = {
    disableButtonUneditable: disableButtonUneditable,
    enableSubmitButton: enableSubmitButton,
    disableSubmitButton: disableSubmitButton,
};
